/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `CUSTOM_API` - CUSTOM_API
 * * `OPEN_AI_ASSISTANT` - OPEN_AI_ASSISTANT
 * * `AZURE_OPEN_AI_ASSISTANT` - AZURE_OPEN_AI_ASSISTANT
 * * `POE` - POE
 * * `SPITCH` - SPITCH
 * * `AINO` - AINO
 * @export
 */
export const SingleTurnChatProtocolEnum = {
  customApi: 'CUSTOM_API',
  openAiAssistant: 'OPEN_AI_ASSISTANT',
  azureOpenAiAssistant: 'AZURE_OPEN_AI_ASSISTANT',
  poe: 'POE',
  spitch: 'SPITCH',
  aino: 'AINO',
} as const;
export type SingleTurnChatProtocolEnum = (typeof SingleTurnChatProtocolEnum)[keyof typeof SingleTurnChatProtocolEnum];

export function instanceOfSingleTurnChatProtocolEnum(value: any): boolean {
  for (const key in SingleTurnChatProtocolEnum) {
    if (Object.prototype.hasOwnProperty.call(SingleTurnChatProtocolEnum, key)) {
      if ((SingleTurnChatProtocolEnum as Record<string, SingleTurnChatProtocolEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SingleTurnChatProtocolEnumFromJSON(json: any): SingleTurnChatProtocolEnum {
  return SingleTurnChatProtocolEnumFromJSONTyped(json, false);
}

export function SingleTurnChatProtocolEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatProtocolEnum {
  return json as SingleTurnChatProtocolEnum;
}

export function SingleTurnChatProtocolEnumToJSON(value?: SingleTurnChatProtocolEnum | null): any {
  return value as any;
}
